import { BrokerMedia } from '@insurance/api/requests'
import { MenuProps } from 'antd'
import { TFunction } from 'i18next'
import { Trash } from 'iconsax-react'

import { MediaActionsTypes } from '../MediaActions'

const iconProps = { size: 16 }

export const getActionColumnMenu =
  (
    onClick: (
      modal: { type: MediaActionsTypes; data: BrokerMedia } | null
    ) => void,
    t: TFunction
  ) =>
  (data: BrokerMedia): MenuProps['items'] => {
    return [
      {
        label: t('delete'),
        key: 'delete',
        icon: <Trash {...iconProps} />,
        danger: true,
        onClick: () => onClick({ data, type: 'delete' })
      }
    ]
  }
